import script from "./receive-insurance-all.vue?vue&type=script&lang=ts&setup=true"
export * from "./receive-insurance-all.vue?vue&type=script&lang=ts&setup=true"

import "./receive-insurance-all.vue?vue&type=style&index=0&id=4be9b633&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be9b633"]])

export default __exports__